import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, Subscription, interval, map, catchError } from "rxjs";
import { Injectable } from "@angular/core";
import { LanguageUpdateService } from "../language/language.service";
import { MyJwksValidationHandler } from "src/app/auth/providers/MyJwksValidationHandler";
import { OAuthService } from "angular-oauth2-oidc";
import { RefreshTokenResponse } from "src/app/auth/models/models";
import { Router } from "@angular/router";
import { authConfig } from "../../models/authConfig";
import { AccountServiceService } from "src/app/services/AccountService";
import { AppConsts } from "../../app-consts";
import { App } from "src/app/admin/services/permission-checker";
import {
  ForgotPasswordDto,
  GetUserEmailDto,
  ResetPasswordDto,
  SignInInputModel,
  SignInOutputModel,
  UserProfileDto,
} from "src/app/admin/models/account-model";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private isLoggedIn: boolean = false;
  private isAuthorized: boolean = false;
  private permissions: string[];
  private currentLang: string;

  tokenRefreshmentSubscription: Subscription;
  tokenRefreshmentInterval = interval(180000);
  private env: any;

  constructor(
    private _oauthService: OAuthService,
    private _router: Router,
    private _languageService: LanguageUpdateService,
    private http: HttpClient,
    private accountService: AccountServiceService
  ) {
    this.currentLang = this._languageService.getCurrentLangSt();

    console.log("calling handleRefreshTokenOnLoad");
    //refresh token on page load if its close to expire :
    this.handleRefreshTokenOnLoad();

    //token refresh interval
    this.tokenRefreshmentSubscription = this.tokenRefreshmentInterval.subscribe(
      (val) => this.setRefreshTokenInsessionStorage()
    );
  }

  checkIfLoggedIn(): boolean {
    this.isLoggedIn = this._oauthService.hasValidAccessToken();
    return this.isLoggedIn;
  }

  checkIfAuthorized(role: string, reqPermissions?: string[]): boolean {
    let issues: number = 0;
    const user: string | null = sessionStorage.getItem("user");
    this.permissions = user ? JSON.parse(user)["permissions"] : null;

    if (reqPermissions && reqPermissions.length > 0) {
      reqPermissions.filter((permission, i, arr) => {
        if (this.permissions.indexOf(permission) === -1) {
          issues++;
          return false;
        } else {
          return true;
        }
      });

      this.isAuthorized = issues === 0;
    } else {
      this.isAuthorized = true;
    }

    return this.isAuthorized;
  }

  configure(): void {
    this._oauthService.events.subscribe((res: { type: any }) => {
      switch (res.type) {
        case "token_received":
          if (this._router.url.indexOf("keyclock") > 0) {
            this.navigateToHome();
          }
          break;
        default:
          break;
      }
    });
    if (!this._oauthService.hasValidAccessToken()) {
      this._oauthService.tokenValidationHandler = new MyJwksValidationHandler();
      this._oauthService.loadDiscoveryDocumentAndLogin().then(
        (v) => {
          //this._oauthService.logoutUrl = `https://iam.test.thiqah.sa:4433/auth/realms/mci/protocol/openid-connect/logout?client_id={{client_id}}&id_token={{id_token}}&redirect_uri=${window.location.origin}`;
          this._oauthService
            .loadUserProfile()
            .then(
              (userInfo) => {
                if (sessionStorage.getItem(AppConsts.Session_PaymentUrl)) {
                  this.navigateToPayment();
                } else {
                  this.navigateToHome();
                }
              },
              (res) => {
                this._oauthService.setupAutomaticSilentRefresh();
              }
            )
            .catch((reason) => {});
        },
        (err) => {}
      );
    } else {
      this._oauthService.setupAutomaticSilentRefresh();
      if (sessionStorage.getItem(AppConsts.Session_PaymentUrl)) {
        this.navigateToPayment();
      } else {
        this.navigateToHome();
      }
    }
  }

  reConfigure(config: any): void {
    // let url = document.location.href;
    // if (url.indexOf('hint=monshaat') != -1) {
    //   sessionStorage.setItem("IsMonshaat", "true");
    //   authConfig.customQueryParams["kc_idp_hint"] = "monshaat";
    // }
    // else if (sessionStorage.getItem("IsMonshaat") == "true") {
    //   authConfig.customQueryParams["kc_idp_hint"] = "monshaat";
    // }
    // else {
    //   authConfig.customQueryParams["kc_idp_hint"] = "";
    // }
    this.env = config.getConfig();
    if (!this._oauthService.logoutUrl) {
      authConfig.issuer = this.env.realm_url;
      authConfig.clientId = this.env.client_id;
      authConfig.logoutUrl = this.env.realm_url + authConfig.logoutUrl;
      this._oauthService.configure(authConfig);
    }
  }

  navigateToLogin() {
    this._router.navigate([this.currentLang]);
  }

  navigateToHome() {
    let lang = sessionStorage.getItem(AppConsts.Session_Lang);
    this._router.navigate([`/${lang}/franchises`]);
  }

  navigateToPayment() {
    const language: string | null = sessionStorage.getItem(
      AppConsts.Session_Lang
    );
    const payment: string | null = sessionStorage.getItem(
      AppConsts.Session_PaymentUrl
    );
    if (language && payment) {
      let paymentUrl = language + payment;
      this._router.navigateByUrl(paymentUrl);
    }
  }

  refreshToken(): Observable<RefreshTokenResponse> {
    var body =
      "client_id=" +
      this._oauthService.clientId +
      "&redirect_uri=" +
      this._oauthService.redirectUri +
      "&grant_type=refresh_token" +
      "&refresh_token=" +
      this._oauthService.getRefreshToken();

    console.log("body of refresh token" + body);

    let url = this.env.refreshTokenUrl; // config.refreshTokenUrl;

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    };

    return this.http.post(url, body, httpOptions);
  }

  logout(): any {
    var body =
      "client_id=" +
      this._oauthService.clientId +
      "&refresh_token=" +
      this._oauthService.getRefreshToken();

    let url = this.env.logoutUrl;

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    };

    return this.http.post(url, body, httpOptions);
  }

  setRefreshTokenInsessionStorage() {
    this.refreshToken().subscribe((res) => {
      if (res && res.access_token && res.refresh_token && res.expires_in) {
        sessionStorage.setItem(AppConsts.Session_AccessToken, res.access_token);
        sessionStorage.setItem(
          AppConsts.Session_RefreshToken,
          res.refresh_token
        );

        let currentDate = new Date();
        currentDate.setSeconds(currentDate.getSeconds() + res.expires_in);

        sessionStorage.setItem(
          AppConsts.Session_ExpiresAt,
          currentDate.getTime().toString()
        );
      }
    });
  }

  handleRefreshTokenOnLoad() {
    window.onload = () => {
      let tokenExpiryString: string | null = sessionStorage.getItem(
        AppConsts.Session_ExpiresAt
      );

      let currentokenExpiryDate = tokenExpiryString
        ? new Date(parseInt(tokenExpiryString))
        : null;
      console.log("current token expiry" + currentokenExpiryDate);

      let currentDate = new Date();
      currentDate.setMinutes(currentDate.getMinutes() + 2);

      if (currentokenExpiryDate && currentDate >= currentokenExpiryDate) {
        console.log("current date equal or greater than current token expire");
        this.setRefreshTokenInsessionStorage();
      }
    };
  }
  checkadminLogin(model: SignInInputModel): Observable<SignInOutputModel> {
    return this.accountService.Authenticate(model);
  }
  adminLogin(signInModel: SignInInputModel): Observable<SignInOutputModel> {
    return this.accountService.Login(signInModel);
  }
  adminLogout() {
    this.accountService.Logout().subscribe(
      (result: boolean) => {
        if (result) {
          App.auth.permissions = [];
          localStorage.clear();
          this._router.navigate(["/adminlogin"]);
        }
      },
      (error) => {
        localStorage.clear();
        this._router.navigate(["/adminlogin"]);
      }
    );
  }
  adminProfile(): Observable<UserProfileDto> {
    return this.accountService.GetProfile();
  }
  adminPermissions(): Observable<string[]> {
    return this.accountService.GetPermissions();
  }

  checkIfAdminLoggedIn() {
    var route = window.location.href;
    if (route.toLowerCase().includes(AppConsts.AdminContext.toLowerCase())) {
      if (localStorage.getItem(AppConsts.Session_AccessToken)) {
        //this._router.navigate(["/admin/InternalFranchises"]);
      } else {
        this._router.navigate(["/adminlogin"]);
      }
    }
  }
  redirectToTwoFactorAuthPage(result: SignInInputModel): void {
    this._router.navigateByUrl("/adminlogin/twofactor-auth", { state: result });
  }

  handleAdminLogin(result: SignInOutputModel, redirectUrl: string) {
    if (result) {
      localStorage.setItem(
        AppConsts.Session_AccessToken,
        result.accessToken ?? ""
      );
      localStorage.setItem(
        AppConsts.Session_RefreshToken,
        result.refreshToken ?? ""
      );

      if (result.forceChangePasswordIdentifier) {
        localStorage.setItem(
          AppConsts.Session_ForceChangePassword,
          result.forceChangePasswordIdentifier
        );
        this._router.navigate(["/reset-password"]);
      } else {
        this._router.navigate([redirectUrl]);
      }
    }
  }
  handleAdminPermission(result: string[]) {
    if (result) {
      localStorage.setItem(
        AppConsts.Session_Permissions,
        JSON.stringify(result)
      );
    }
  }
  getCaptcha(key: string): Observable<any> {
    return this.accountService.GetChaptcha(key);
  }
  emailActivation(id: string): Observable<void> {
    return this.accountService.EmailActivation(id);
  }
  forgotPassword(input: ForgotPasswordDto): Observable<void> {
    return this.accountService.ForgotPassword(input);
  }
  getUserEmail(id: string): Observable<GetUserEmailDto> {
    return this.accountService.GetUserEmail(id);
  }
  resetPassword(input: ResetPasswordDto): Observable<void> {
    return this.accountService.ResetPassword(input);
  }
}
